import { rest } from "msw";
import { returnOkPostResponse } from "../responseResolvers/utils";

const mockedResponse = { request_id: "f50b187e-7eb6-4792-b08f-0b6e30dbcbd8" };

export const rumHandlers = [
    rest.post("https://rum.browser-intake-datadoghq.eu/api/v2/rum", returnOkPostResponse(mockedResponse)),
    rest.post("https://session-replay.browser-intake-datadoghq.eu/api/v2/replay", returnOkPostResponse()),
];
